import script from "./GetStartedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GetStartedCard.vue?vue&type=script&setup=true&lang=js"

import "./GetStartedCard.vue?vue&type=style&index=0&id=54e92682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e92682"]])

export default __exports__